<template>
  <div class="error-container">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 text-center">
          <img src="@/assets/img/icons/404.svg" class="w-75" alt />
        </div>
        <div class="col-12 col-md-6 align-self-center">
          <div>
            <h1>404</h1>
            <p>
              Sorry but the page you are looking for doest not exist, have been
              removed, Name might have changed or Temporarily unavailable.
            </p>
            <router-link to="/" class="btn-black-lg px-5"
              >Back To Home</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { backendSocket, EventBus } from "@/main.js";
import { BASEURL } from "@/config/index";
export default {
  methods: {},
  beforeMount() {
    if (
      String(window.location.href).includes('iraq-dashboard-v1.empirecinemas.com')
    ) {
      let url =  new URL(window.location.href)
      url.hostname = 'https://iraq-dashboard-v-1.empirecinemas.com'
      window.location.href = url.href
    }
    else {
      console.log({
        'window.location.href': window.location.href
      })
    }
  },
  mounted() {
  }
};
</script>

<style>
.error-container h1 {
  font-size: 75px;
  line-height: 1;
  margin-bottom: 5px;
  font-weight: bolder;
}
.error-container p {
  font-size: 18px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Error/404.vue